import { render } from "./SidenavBtn.vue?vue&type=template&id=05e6af76&scoped=true"
import script from "./SidenavBtn.vue?vue&type=script&lang=js"
export * from "./SidenavBtn.vue?vue&type=script&lang=js"

import "./SidenavBtn.vue?vue&type=style&index=0&id=05e6af76&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e6af76"]])

export default __exports__